export async function trackEvent(eventName, eventParams = {}) {
  if (typeof window.gtag === 'function') {
    const params = {
      ...eventParams,
      // debug_mode: true,
    };
    await window.gtag('event', eventName, params);
  } else {
    console.warn('gtag warn');
  }
}
